import { render, staticRenderFns } from "./AuthorizedSigners.vue?vue&type=template&id=f9d3a65c&scoped=true"
import script from "./AuthorizedSigners.vue?vue&type=script&lang=js"
export * from "./AuthorizedSigners.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedSigners.vue?vue&type=style&index=0&id=f9d3a65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d3a65c",
  null
  
)

export default component.exports